<template>
  <section
    ref="section11"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="12"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex max-w-3xl flex-col gap-11 lg:w-full">
        <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
          <div><v-icon icon="list-clock" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="text-heading-3-desktop">
              Od kdaj je nepremičnina na voljo?
            </div>
          </div>
        </figure>
        <form method="POST" :action="routes.submitForm" id="select-occupancy-date">
          <v-csrf-token></v-csrf-token>
          <figure>
            <figure
              class="grid grid-cols-2 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-6"
            >
              <div
                @click="clearDate()"
                name="takoj"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.verfuegbar_ab ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="verfuegbar_ab"
                  id="kdajBoVasaNepremicninaVseljiva-takoj"
                  value="now"
                  class="hidden"
                  v-model="availability"
                />

                <label
                  for="kdajBoVasaNepremicninaVseljiva-takoj"
                  class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                >
                  <v-icon icon="calendar-check" size="5"></v-icon>
                  <span class="pointer-events-none select-none">Takoj</span>
                </label>
              </div>
              <div
                name="v-gradnji"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.verfuegbar_ab ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="verfuegbar_ab"
                  id="kdajBoVasaNepremicninaVseljiva-kasneje"
                  value="later"
                  class="hidden"
                  v-model="availability"
                />

                <label
                  for="kdajBoVasaNepremicninaVseljiva-kasneje"
                  class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                >
                  <v-icon icon="clock" size="5"></v-icon>

                  <span class="pointer-events-none select-none">Kasneje</span>
                </label>
              </div>
            </figure>
            <figure class="ml-auto mr-auto max-w-lg mt-11" v-show="availability == 'later'">
              <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-8">
                <li class="col-span-4">
                  <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.abdatum ? 'has-errors' : '')]">
                    <label
                      for="datumKdajBoVseljivo"
                      class="w-full text-body-medium-button"
                    >
                      <div class="label flex flex-col gap-[10px]">
                        <div class="flex items-center gap-3">
                          <v-icon icon="calendar-dot-mono" size="4"></v-icon>
                          <span>
                            Datum
                            <sup>*</sup></span
                          >
                        </div>
                      </div>
                    </label>
                    <v-datepicker
                      ref="datumKdajBoVseljivoRef"
                      v-model="dateFrom"
                      :formatter="dateFormatter"
                      id="datumKdajBoVseljivo"
                      name="abdatum"
                      placeholder="Datum"
                      as-single
                    />
                  </div>
                </li>
              </ul>
            </figure>
          </figure>
        </form>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm('select-occupancy-date')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import VueTailwindDatepicker from "vue-tailwind-datepicker";
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
    "v-datepicker": VueTailwindDatepicker,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      availability: null,
      dateFrom: null,
      dateFormatter: {
        date: 'D.M.YYYY',
        month: 'MMM'
      },
    };
  },
  mounted() {
    this.availability = (this.old.verfuegbar_ab ? this.old.verfuegbar_ab : this.stepData.verfuegbar_ab)
    this.dateFrom = (this.old.abdatum ? this.old.abdatum : (this.stepData.abdatum ? this.stepData.abdatum : {startDate : null}))
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
    clearDate() {
      this.$refs.datumKdajBoVseljivoRef.clearPicker()
    }
  },
  computed: {
    validated() {
      if(this.availability == 'later' && !this.dateFrom) return false
      if(!this.availability) return false

      return true;
    }
  },
};
</script>
